import React from 'react';
import SectionSubscriptions from "./home/SectionSubscriptions";
import SecureCheckout from "./home/SecureCheckout";

const Pricing = () => {
    return (
        <div style={{ marginTop: '100px' }}>
            <SectionSubscriptions />
            <SecureCheckout />
        </div>
    );
};

export default Pricing;